export default "__VITE_ASSET__23173e71__"